import { Box, Typography, Paper } from '@mui/material';

interface StatsCardProps {
  totalActiveDays: number;
  longestStreakDays: number;
  currentStreakDays: number;
}

export function StatsCard({ totalActiveDays, longestStreakDays, currentStreakDays }: StatsCardProps) {
  return (
    <Paper sx={{ 
      backgroundColor: '#1f2937',
      color: '#ffffff',
      borderRadius: 2, 
      padding: 3, 
      width: '100%', 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center',
      boxShadow: 'none'
    }}>
      <Box sx={{ marginBottom: 2 }}>
        <Typography sx={{ 
          color: '#9ca3af', 
          fontSize: '0.875rem', 
          marginBottom: '8px',
          fontWeight: 400
        }}>
          Total Active Days
        </Typography>
        <Typography sx={{ 
          color: '#22c55e', 
          fontSize: '1.5rem', 
          fontWeight: 500
        }}>
          {totalActiveDays}
        </Typography>
      </Box>

      <Box sx={{ 
        display: 'flex', 
        gap: 2,
        borderTop: '1px solid #374151',
        paddingTop: 2
      }}>
        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Box sx={{
            backgroundColor: '#374151',
            borderRadius: 1,
            padding: '12px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span style={{ fontSize: '14px' }}>🔥</span>
              <Typography sx={{ 
                color: '#4ade80', 
                fontSize: '0.75rem',
                fontWeight: 500
              }}>
                Current Streak
              </Typography>
            </Box>
            <Typography sx={{ 
              color: '#ffffff', 
              fontSize: '1.125rem',
              fontWeight: 500
            }}>
              {currentStreakDays}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Box sx={{
            backgroundColor: '#374151',
            borderRadius: 1,
            padding: '12px',  
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span style={{ fontSize: '14px' }}>🏆</span>
              <Typography sx={{ 
                color: '#fb923c', 
                fontSize: '0.75rem',
                fontWeight: 500
              }}>
                Max Streak
              </Typography>
            </Box>
            <Typography sx={{ 
              color: '#ffffff', 
              fontSize: '1.125rem',
              fontWeight: 500
            }}>
              {longestStreakDays}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}